export default __webpack_public_path__ + "3ba550eedff465b7ffc6e24014af72be.png";